<template>
  <div>
    <div class="profile-container" v-click-outside="hideMenu" v-if="userEmail">
      <div class="avatar-container" @click="isShow = !isShow">
        <img class="profile-image" :src="image" alt="" />
      </div>
      <div class="info-container" v-show="isShow">
        <div class="first-info-block profile-account-container">
          <div class="profile-avatar-img">
            <img class="profile-image" :src="image" alt="" />
          </div>
          <div class="profile-username-txt">
            {{ userName }}
          </div>
          <div class="profile-email-txt">
            {{ userEmail }}
          </div>
        </div>
        <div class="middle-info-block">
          <div class="linked-devices icon-container" @click="isShow = !isShow">
            <router-link to="/management">
              {{ $t('COMMON.str03') }}: {{ deviceCount }}
            </router-link>
          </div>
        </div>
        <div v-if="!isMobile" class="middle-info-block">
          <div class="icon-container sound-wrapper">
            <div>{{ $t('COMMON.str16') }}</div>
            <switcher :checked="hasSound" @change="toggleSound" />
          </div>
        </div>
        <div class="middle-info-block" @click="showThemeList">
          <div class="icon-container theme-wrapper arrow-icon">
            <div class="label-container">
              {{ $t(selectedTheme) }}
            </div>
          </div>
        </div>
        <div class="middle-info-block" @click="showLanguageList">
          <div class="icon-container lang-wrapper arrow-icon">
            <div class="label-container">
              {{ selectedLang }}
            </div>
          </div>
        </div>
        <div class="middle-info-block" @click="showTimeZoneList">
          <div class="icon-container timezone-wrapper arrow-icon">
            <div class="label-container one-line-text">
              {{ selectedTimeZone }}
            </div>
          </div>
        </div>
        <div class="last-info-block">
          <div class="logout-container" @click="logoutConfirm">
            <div class="header-text">
              {{ $t('COMMON.str06') }}
            </div>
          </div>
        </div>
        <transition name="slider">
          <menu-slider
            v-if="showSlider"
            @close="showSlider = false"
            @callback="callback"
            :item-list="itemlist"
            :title="title"
            :selected="selectingItem"
            :searchbox="hasSearchBox"
          />
        </transition>
      </div> </div
    ><div v-else>
      <a :href="$t('LINKS.str04')" v-show="lang">
        <div class="btn-signout">{{ $t('COMMON.str06') }}</div>
      </a>
    </div>
  </div>
</template>
<script>
import Switcher from '@/components/common/Switcher';
import MenuSlider from '@/components/layout/MenuSlider';
import {
  EventBus,
  LANGLIST,
  THEMELIST,
  TIMEZONELIST /*, SOLLAE_BASE_URL */,
  getTheme,
  TIMEDIFF_TOLERANCE,
  setStorageItem,
  getStorageItem,
  removeStorageItem,
} from '@/js/utils';

export default {
  name: 'UserMenu',
  props: {
    nonRequired: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Switcher,
    MenuSlider,
  },
  data() {
    return {
      isShow: false,
      title: null,
      itemlist: null,
      selectingItem: null,
      callback: null,
      showSlider: false,
      hasSearchBox: false,
    };
  },
  computed: {
    deviceCount() {
      return this.$store.getters['device/numOfDevices'];
    },
    lang() {
      return this.$store.getters['user/language']; // || this.$store.getters['local/language'];
    },
    theme() {
      return this.$store.getters['user/theme'];
    },
    currentTheme() {
      return this.isMobile
        ? this.$store.getters['user/mobileTheme']
        : this.$store.getters['user/desktopTheme'];
    },
    timezone() {
      return this.$store.getters['user/timezoneOffset'];
    },
    /*
    googleScope() {
        return this.$store.getters['user/googleScope'];
    },
    */
    hasSound() {
      return this.$store.getters['local/enableSound'];
    },
    selectedLang() {
      const lang = LANGLIST.find((l) => l.value === this.lang);
      return lang ? lang.label : '';
    },
    selectedTheme() {
      const theme = THEMELIST.find((l) => l.value === this.currentTheme);
      return theme ? theme.label : '';
    },
    selectedTimeZone() {
      const timezone = TIMEZONELIST.find((l) => l.value === this.timezone);
      return timezone ? timezone.label : '';
    },
    image() {
      return this.$store.getters['user/profilePic'];
    },
    userName() {
      return this.$store.getters['user/userName'];
    },
    userEmail() {
      return this.$store.getters['user/userEmail'];
    },
    isMobile() {
      return this.$store.getters['local/isMobile'];
    },
    systemTime() {
      return this.$store.getters['user/systemTime'];
    },
    /*,
    langUrl() {
      return this.$store.getters['user/langUrl']
    } */
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        if (this.nonRequired) return;
        if (this.$i18n.locale !== this.lang) this.$i18n.locale = this.lang;
      },
    },
    userEmail() {
      if (this.nonRequired) return;
      if (this.userEmail) {
        const lastAccount = getStorageItem(process.env.LAST_ACCOUNT);
        if (lastAccount && lastAccount !== this.userEmail) {
          removeStorageItem(process.env.LAST_URL_KEY);
        }
        setStorageItem(process.env.LAST_ACCOUNT, this.userEmail);

        const lastUrl = getStorageItem(process.env.LAST_URL_KEY);
        if (lastUrl) {
          removeStorageItem(process.env.LAST_URL_KEY);
          this.$router.push(lastUrl);
        }
        if (!this.selectedTimeZone) {
          const timezone = new Date().getTimezoneOffset();
          const msg = this.$t('DIALOG.str38');
          const params = {
            title: this.$t('DIALOG.str22'),
            content: [
              this.$t('DIALOG.str33') +
                ': ' +
                TIMEZONELIST.find((l) => l.value === timezone).label,
              this.$t('DIALOG.str34'),
            ],
            btnConfirm: this.$t('DIALOG.str13'),
            btnCancel: this.$t('DIALOG.str25'),
            onConfirm: () => {
              this.setTimeZone(timezone);
            },
            onCancel: () => {
              this.setTimeZone(0);
              this.$toast.showInfo({ content: msg });
            },
          };
          this.$modal.show(params);
        }
        if (Math.abs(this.systemTime - Date.now()) > TIMEDIFF_TOLERANCE) {
          this.$toast.showWarning({
            content: [this.$t('COMMON.timeSyncRequired')],
          });
        }

        this.$store.dispatch('user/getFrontendVersion').then((res) => {
          if (res) {
            if (res.version !== process.env.FRONTEND_VERSION) {
              this.$footerMsg.set({
                errMsg: this.$t('COMMON.outdateWarning'),
                errBtn: this.$t('DIALOG.str30'),
                errReload: true,
                priority: 2,
              });
            }
          }
        });
      }
    },
  },
  methods: {
    logoutConfirm() {
      this.isShow = false;
      const params = {
        title: this.$t('DIALOG.str23'),
        content: this.$t('DIALOG.str01'),
        btnConfirm: this.$t('DIALOG.str14'),
        btnCancel: this.$t('DIALOG.str25'),
        onConfirm: () => {
          removeStorageItem(process.env.ACCESS_TOKEN_KEY);
          removeStorageItem(process.env.LAST_ACCOUNT);
          removeStorageItem(process.env.LAST_URL_KEY);
          location.replace(
            process.env.SIGNOUT_URL + location.origin + this.$t('LINKS.str04')
          );
        },
      };
      this.$modal.show(params);
    },
    hideMenu() {
      this.isShow = false;
      this.selectingItem = null;
      this.showSlider = false;
    },
    showLanguageList() {
      this.selectingItem = this.lang;
      this.callback = this.setLanguage;
      this.title = this.$t('COMMON.str29');
      this.itemlist = LANGLIST;
      this.hasSearchBox = false;
      this.showSlider = true;
    },
    showThemeList() {
      this.selectingItem = this.currentTheme;
      this.callback = this.setTheme;
      this.title = this.$t('COMMON.str33');
      this.itemlist = THEMELIST;
      this.hasSearchBox = false;
      this.showSlider = true;
    },
    showTimeZoneList() {
      this.selectingItem = this.timezone;
      this.callback = this.setTimeZone;
      this.title = this.$t('COMMON.str30');
      this.itemlist = TIMEZONELIST;
      this.hasSearchBox = true;
      this.showSlider = true;
    },
    setTheme(mode) {
      if (this.currentTheme !== mode) {
        const nextTheme = getTheme(this.isMobile, this.theme, mode);
        // console.log(nextTheme, mode)
        EventBus.$emit('set-userinfo', { theme: nextTheme });
      }
      this.showSlider = false;
    },
    setLanguage(lang) {
      if (this.userEmail) {
        if (this.lang !== lang) {
          EventBus.$emit('set-userinfo', { language: lang });
        }
      } /* else {
            this.$store.dispatch('local/setLanguage', lang)
        } */
      this.showSlider = false;
    },
    setTimeZone(timezone) {
      if (this.timezone !== timezone) {
        EventBus.$emit('set-userinfo', { timezone_offset: timezone });
      }
      this.showSlider = false;
      // this.$toast.showWarning({ content: 'This function is underconstrution' })
    },
    toggleSound() {
      this.$alarmSound.set(!this.hasSound);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.profile-container {
  position: absolute;
  top: 10px;
  right: 35px;
  width: 30px;
  height: 30px;
}

.sound-wrapper > div {
  width: 12.5em;
}

.avatar-container {
  cursor: pointer;
  height: 100%;
  width: 100%;
}

.profile-image {
  border-radius: 50%;
  width: 100%;
  height: 100%;
  display: block;
}

.profile-avatar-img {
  width: 65px;
  height: 65px;
  margin: 0 auto;
}

.profile-username-txt {
  font-size: 1.1em;
  padding: 5px 0;
}

.profile-email-txt {
  color: #898989;
}

.info-container {
  text-align: center;
  position: absolute;
  width: 18em;
  top: 45px;
  right: 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #fff;
  color: #333740;
  word-break: break-all;
  cursor: default;
  font-family: Nunito, sans-serif;
}

.info-container > div {
  font-size: 0.82em;
}

.first-info-block,
.last-info-block {
  padding: 22.5px 2em;
}

.first-info-block,
.middle-info-block {
  border-bottom: 1px solid #b5b5b5;
}

.middle-info-block {
  padding: 15px 25px;
}

.label-container {
  width: 12.5em;
  word-break: keep-all;
}

.logout-container {
  cursor: pointer;
  border: 1px solid #b5b5b5;
  padding: 5px 0;
  border-radius: 15px;
  width: 12.5em;
  margin: 0 auto;
}

.info-container .icon-container {
  height: 1.6em;
  text-align: left;
  margin: 0 0.5em;
  padding-left: 2.75em;
  width: 14.5em;
  display: flex;
  align-items: center;
}

.info-container .icon-container::before {
  width: 2em;
  height: 2em;
  left: 0;
  top: -0.25em;
}

.arrow-icon {
  cursor: pointer;
}

.arrow-icon::after {
  content: '';
  position: absolute;
  width: 0.5em;
  height: 0.5em;
  border: solid #898989;
  border-width: 0 0.15em 0.15em 0;
}

.linked-devices::before {
  background-image: url(~@/assets/img/icon_linked_device.png);
}

.linked-devices > a {
  color: #333740;
}

.lang-wrapper::before {
  background-image: url(~@/assets/img/icon_lang.png);
}

.timezone-wrapper::before {
  background-image: url(~@/assets/img/icon_timezone.png);
}

.theme-wrapper::before {
  background-image: url(~@/assets/img/icon_theme.png);
}

.sound-wrapper::before {
  background-image: url(~@/assets/img/icon_sound.png);
}

.icon-container::after {
  right: 0.4em;
  top: 0.4em;
  transform: rotate(-45deg);
}

.btn-signout {
  position: absolute;
  width: 60px;
  padding: 2.5px 20px;
  border-radius: 18px;
  transition: background-color 0.2s ease-out;
  margin: 0;
  right: 20px;
  top: 17.5px;
  font-size: 15px;
  text-align: center;
  color: #ed7e57;
  border: 1px solid #ed7e57;
}

.btn-signout:hover {
  color: #333740;
  background-color: #ed7e57;
}

.slider-enter,
.slider-leave-to {
  left: 100%;
  opacity: 0;
}

.slider-enter-active,
.slider-leave-active {
  transition: 0.2s ease;
}

@media screen and (max-width: 799px) {
  .profile-container {
    top: 11px;
    right: 15px;
    width: 28px;
    height: 28px;
  }
}
</style>
